export function isStandalone() {
  if (typeof window === 'undefined') return false;
  try {
    if (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(display-mode: standalone)').matches
    ) {
      return true;
    }
  } catch { /* ignore */ }
  if (typeof window.navigator !== 'undefined' && window.navigator.standalone === true) {
    return true;
  }
  return false;
}

function ua() {
  if (typeof navigator === 'undefined') return '';
  return navigator.userAgent || '';
}

export function isIOS() {
  if (typeof window === 'undefined') return false;
  if (window.MSStream) return false;
  const u = ua();
  if (/iPad|iPhone|iPod/.test(u)) return true;
  // iPadOS 13+ reports Mac UA; disambiguate via touch points
  if (/Mac/.test(u) && typeof navigator !== 'undefined' && (navigator.maxTouchPoints || 0) > 1) {
    return true;
  }
  return false;
}

export function isAndroid() {
  return /Android/.test(ua());
}

export function isIOSSafari() {
  if (!isIOS()) return false;
  const u = ua();
  if (/CriOS|FxiOS|EdgiOS|OPiOS|FBAN|FBAV|Instagram|Line\//.test(u)) return false;
  return /Safari/.test(u);
}

export function isMobile() {
  return isIOS() || isAndroid();
}

export function supportsBeforeInstallPrompt() {
  if (typeof window === 'undefined') return false;
  return 'onbeforeinstallprompt' in window;
}

export function getInstallContext() {
  return {
    standalone: isStandalone(),
    ios: isIOS(),
    iosSafari: isIOSSafari(),
    android: isAndroid(),
    mobile: isMobile(),
    supportsBeforeInstallPrompt: supportsBeforeInstallPrompt(),
  };
}
